import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { validateImportFile } from '@/api/clientImports/clientImportsApi';
import type { ImportPreview } from '@/api/clientImports/clientImportsApi.types';

export function useValidateImportMutation(): UseMutationResult<ImportPreview, Error, File> {
  return useMutation({
    mutationFn: validateImportFile,
  });
}
